module.exports = __webpack_public_path__ + "static/media/slack-hash.f750263e.svg";